import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfiguracionLocal } from '../models/generic/ConfiguracionLocal';
import { Observable } from 'rxjs';
import { Constantes } from '../models/modules/Constantes';
import { ConfiguracionVersion } from '../models/generic/ConfiguracionVersion';
import { UtilitariosService } from './utilitarios.service';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionVersionService {

  ConfigVersion: ConfiguracionVersion;
  versionVisualizar: string = '';

  constructor(private httpClient: HttpClient,
              private utilitariosService: UtilitariosService) { 
    this.CargarVersion();
  }

  CargarVersion() {
    if (this.ConfigVersion === null || this.ConfigVersion === undefined) {
      this.ObtenerVersion(Constantes.CONFIGURACION_VERSION()).subscribe((config: ConfiguracionVersion) => {
        this.ConfigVersion = config;
        if (this.utilitariosService.VerificarContieneDatos(this.ConfigVersion)) {
          this.versionVisualizar = this.ConfigVersion.VersionActualizacion;
          this.versionVisualizar = this.versionVisualizar.replace('RELEASE', `1-${this.utilitariosService.ObtenerFechaTextoConHora(new Date(), '', '-', '')}`);
        }
      });
    }
  }
  
  ObtenerVersion(rutaCarga: string): Observable<any> {
    return this.httpClient.get(rutaCarga);
  }
}
